import { useApi } from '@tm/client-app/src/api'
import { GetPlansResponse } from '@tm/types/api/plans'
import { useEffect, useMemo, useState } from 'react'
import { BillingPlanContext } from './useBillingPlans'

export const BillingPlanContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [plansLoading, setPlansLoading] = useState(false)
  const [plans, setPlans] = useState<GetPlansResponse['plans']>([])
  const [error, setError] = useState<string>()
  const { appApi } = useApi()

  useEffect(() => {
    setPlansLoading(true)
    appApi
      .get<GetPlansResponse>('/v1/plans')
      .then(response => {
        setPlans(response.data.plans)
      })
      .catch((err: Error) => {
        setError(err.message)
      })
      .finally(() => {
        setPlansLoading(false)
      })
  }, [appApi])

  const value = useMemo(() => ({ plans, setPlans, plansLoading, error }), [error, plans, plansLoading])

  return <BillingPlanContext.Provider value={value}>{children}</BillingPlanContext.Provider>
}
